angular.module("Main").controller("Step1Controller", ["$rootScope", "$scope", "$localStorage", "$state", "$stateParams", "$window", "$uibModal", "BookingService", "SessionService",
    function ($rootScope, $scope, $localStorage, $state, $stateParams, $window, $uibModal, BookingService, SessionService) {
        var vm = this;

        vm.imageUrl = BookingService.getAppointmentTypeImagePath();
        vm.openedMenuBar = false;

        var loginHandler = $rootScope.$on("login", function () {
            checkUser();
        });
        var logoutHandler = $rootScope.$on("logout", function () {
            SessionService.clear('globals', 'meetingData', 'meetingDate');
            $localStorage.user = {};
        });
        $scope.$on("destroy", function () {
            unregisterEventHandler();
        });

        var medium = 1200;
        var small = 900;
        var xs = 450;

        function checkLimitLength() {
            if ($window.innerWidth >= medium) {
                vm.limitLength = 5;
            } else if ($window.innerWidth >= small) {
                vm.limitLength = 4;
            } else if ($window.innerWidth >= xs) {
                vm.limitLength = 3;
            } else {
                vm.limitLength = 1;
            }
        }

        checkLimitLength();

        function getKursbuchungLayouKonfiguration() {
            BookingService.getKursbuchungLayouKonfiguration().then(function (data) {
                vm.kursbuchungConfig = data;
            });
        }

        function loadConfigs() {
            BookingService.loadLayoutConfiguration().then(function (data) {
                vm.layoutSettings = angular.fromJson(data.Layout);
                vm.layoutSettings.BuchungslimitMitgliedZulassen = data.BuchungslimitMitgliedZulassen;
                getKursbuchungLayouKonfiguration();
            })
        }

        function loadCurrency() {

            return new Promise((resolve) => {
                BookingService.getCurrency().then(function (data) {
                    vm.currency = data;
                    if (vm.currency.Waehrung === "EUR")
                        vm.currency.Waehrung = "€";
                    resolve(vm);
                })

            })
        }


        if (!SessionService.getSessionId()) {
            if (_.isUndefined($stateParams.id)) {
                SessionService.setAuthDataId($stateParams.cid, false);
                $state.go('angebot', {sid: SessionService.getSessionId(), cid: $stateParams.cid, id: false});
            } else {
                SessionService.setAuthDataId($stateParams.cid, $stateParams.id, false, $stateParams.id === 'tt');
                $state.go('angebot', {sid: SessionService.getSessionId(), cid: $stateParams.cid, id: $stateParams.id});
            }
            start();
        } else
            start();

        async function start() {
            try {
                await SessionService.clear('meetingData', 'meetingDate');
                await checkUser();
                await loadCurrency();
                init();
            }
            catch {

            }
        }

        function unregisterEventHandler() {
            loginHandler();
            logoutHandler();
        }

        function checkUser() {
            BookingService.loadNutzungsrechteListe().then(function (data) {
                vm.nutzungsrechteEndpointFailed = false;
                vm.nutzungsrechte = data.data;
                vm.nutzungsrechte.forEach(item => {
                    item.Name = item.Bezeichnung + "(" + item.Kurzzeichen + ")"
                })
            }).catch(function (error) {
                vm.nutzungsrechteEndpointFailed = true;
            });
            if ($localStorage.user && !_.isUndefined($localStorage.user.expiryTime)) {
                let expiryTime = JSON.parse($localStorage.user.expiryTime);
                let now = new Date;
                if (now.getTime() > expiryTime) {
                    SessionService.clear('globals', 'meetingData', 'meetingDate', 'kursData');
                    vm.isLoggedIn = false;
                    vm.username = "";
                    $localStorage.user = {};
                    $rootScope.$emit("logout");
                    $state.go('angebot', {cid: SessionService.getAuthData(), id: SessionService.getAuthIdData()})
                }
            }

            vm.isMember = $localStorage.user && $localStorage.user.username && $localStorage.user.username !== '' ? $localStorage.user.isMember : false;
            vm.isLoggedIn = !_.isNil($localStorage.user) && !_.isUndefined($localStorage.user.username);
            vm.username = $localStorage.user ? $localStorage.user.username : null;
            vm.isPayPal = $localStorage.user ? $localStorage.user.isPayPal : false;
            vm.isBonitaet = $localStorage.user ? $localStorage.user.isBonitaet : false;
            vm.isTrainer = $stateParams.id === 'tt';
        }

        async function init() {
            try {
                await checkUser();
                await loadConfigs();
                await checkTerminarten();
            }
            catch {

            }
        }

        function checkTerminarten() {
            SessionService.clear('meetingData', 'meetingDate');
            if (_.isUndefined($stateParams.id)) {
                var uuid = false;
            } else if ($stateParams.id) {
                var uuid = $stateParams.id;
                if (!_.isUndefined($stateParams.dt)) {
                    var uuid2 = $stateParams.dt
                }
            }

            vm.withoutStep1 = false;
            vm.termineInactiv = false;
            BookingService.checkLinkConfig(uuid, uuid2).then(function (data) {
                if (data.LinkIdNotFound === true) {
                    vm.idNotFound = true;
                } else {
                    if (data.IsInactiv === true) {
                        vm.termineInactiv = true;
                        vm.isInFuture = data.IsInFuture;
                        vm.isInPast = data.IsInPast;
                        if (data.IsInFuture === true) {
                            vm.futureDate = data.FutureDate;
                        }
                    } else {
                        // vm.IsSlider = data.SliderData.IsSlider;
                        // vm.StartTimeSlider = data.SliderData.SliderStart;
                        // vm.EndeTimeSlider = data.SliderData.SliderEnde;
                        if (data.IsOnlyOneAppointmentType === true) {
                            vm.withoutStep1 = true;
                            let subcategory = data.AppointmentTypeData;
                            subcategory.SliderData = {};
                            subcategory.SliderData.IsSlider = data.AppointmentTypeData.IsSlider;
                            subcategory.SliderData.StartTimeSlider = data.AppointmentTypeData.StartTimeSlider;
                            subcategory.SliderData.EndeTimeSlider = data.AppointmentTypeData.EndeTimeSlider;
                            if (vm.nutzungsrechteEndpointFailed === false && subcategory.Buchungssystem_Terminarten.MitgliedsOption !== 3 && subcategory.TerminartNutzungsrechte.length > 0) {
                                _.forEach(subcategory.TerminartNutzungsrechte, function (nutzungsrecht) {
                                    nutzungsrecht.Bezeichnung = _.find(vm.nutzungsrechte, {'LeistungsartId': nutzungsrecht.Nutzungsrecht_Nr}).Bezeichnung
                                })
                            }
                            SessionService.setSubCategory(subcategory, vm.currency, vm.withoutStep1);
                            unregisterEventHandler();
                            $state.go('termin', {subcategory: subcategory, cid: $stateParams.cid, id: $stateParams.id, dt: $stateParams.dt})
                        } else {
                            if (data.AllTerminarten === true) {
                                BookingService.getCategoriesAndSubcategories().then(function (categories) {
                                    vm.categories = categories;
                                    vm.categories = _.sortBy(vm.categories, 'Sortierung');
                                    vm.current = [];
                                    if (vm.categories.length > 0) {
                                        vm.selectedCategoryNr = vm.categories[0].Nr;
                                        checkImages(categories[0].Typen)
                                        checkSelectedCategory(categories)
                                    }
                                    if ($window.innerWidth >= 700) {
                                        for (let i = 0; i < vm.limitLength; ++i) {
                                            vm.current[i] = vm.selectedCategory[i];
                                        }
                                    } else {
                                        vm.current = vm.selectedCategory;
                                    }

                                });
                            } else {
                                let ids = data.TerminartenIds;

                                BookingService.getCategoriesAndSubcategoriesSelection(ids).then(async function (categories) {
                                    try {
                                        vm.categories = categories;
                                        vm.categories = _.sortBy(vm.categories, 'Sortierung');
                                        vm.current = [];
                                        if (vm.categories.length > 0) {
                                            vm.selectedCategoryNr = vm.categories[0].Nr;
                                            await checkImages(categories[0].Typen)
                                            await checkSelectedCategory(categories)
                                        }
                                        if ($window.innerWidth >= 700) {
                                            for (let i = 0; i < vm.limitLength; ++i) {
                                                vm.current[i] = vm.selectedCategory[i];
                                            }
                                        } else {
                                            vm.current = vm.selectedCategory;
                                        }
                                    }
                                    catch {

                                    }

                                });
                            }

                        }
                    }
                }
            })


        }

        function checkImages(typen) {
            _.forEach(typen, function (c) {
                BookingService.getTerminImage(c.Nr).then(function (image) {
                    c.Bild = image;
                })
            })
            return typen
        }

        function checkSelectedCategory(categories) {
            categories = _.sortBy(vm.categories, 'Sortierung');
            vm.selectedCategory = categories[0].Typen;
            vm.selectedCategory = _.sortBy(vm.selectedCategory, 'Sortierung');
            checkImages(categories[0].Typen)
            vm.subCategories = _.chunk(vm.categories[0].Typen, 4);
            if (vm.selectedCategory.length < vm.limitLength) {
                vm.limitLength = vm.selectedCategory.length
            }
            vm.begin = 0;
            vm.showMover = vm.selectedCategory.length > vm.limitLength;
            vm.chunkedCategory = _.chunk(vm.selectedCategory, vm.limitLength);
        }

        vm.selectCategory = function (category) {
            checkLimitLength();
            checkImages(category.Typen)
            vm.current = [];
            if (category.Typen.length > 0) {
                _.sortBy(category.Typen, 'Sortierung');
                vm.selectedCategoryNr = category.Nr;
                vm.subCategories = _.chunk(category.Typen, 4);
                vm.selectedCategory = category.Typen;
                vm.chunkedCategory = _.chunk(vm.selectedCategory, vm.limitLength);
                vm.begin = 0;
                vm.showMover = vm.selectedCategory.length > vm.limitLength;
            }
            if (vm.selectedCategory.length < vm.limitLength) {
                vm.limitLength = vm.selectedCategory.length
            }

            if ($window.innerWidth >= 700) {
                for (let i = 0; i < vm.limitLength; ++i) {
                    vm.current[i] = vm.selectedCategory[i];
                }
            } else {
                vm.current = vm.selectedCategory;
            }
        };

        vm.selectAndSetCookieSubcategory = function (subcategory, currency) {
            //ToDo wenn noch keine API mit NR , Nur Mitglieder abfangen
            BookingService.loadNutzungsrechteListe().then(function (data) {
                vm.nutzungsrechteEndpointFailed = false;
                vm.nutzungsrechte = data.data;
                vm.nutzungsrechte.forEach(item => {
                    item.Name = item.Bezeichnung + "(" + item.Kurzzeichen + ")"
                })
                    subcategory.SliderData = {};
                    subcategory.SliderData.IsSlider = vm.IsSlider;
                    subcategory.SliderData.StartTimeSlider = vm.StartTimeSlider;
                    subcategory.SliderData.EndeTimeSlider = vm.EndeTimeSlider;
                    if(subcategory.TerminartNutzungsrechte.length > 0) {
                        _.forEach(subcategory.TerminartNutzungsrechte, function (nutzungsrecht) {
                            nutzungsrecht.Bezeichnung = _.find(vm.nutzungsrechte, {'LeistungsartId': nutzungsrecht.Nutzungsrecht_Nr}).Bezeichnung
                        })
                    }
                    subcategory.BuchungslimitMitgliedZulassen = vm.layoutSettings.BuchungslimitMitgliedZulassen;
                    SessionService.setSubCategory(subcategory, currency, false);
                    unregisterEventHandler();
                    $state.go('termin', {subcategory: subcategory, cid: $stateParams.cid, id: $stateParams.id, dt: $stateParams.dt})
            }).catch(function (error) {
                vm.nutzungsrechteEndpointFailed = true;
                if (vm.isTrainer === false && subcategory.Buchungssystem_Terminarten.MitgliedsOption === 1 && !vm.isMember) {
                    $uibModal.open({
                        templateUrl: "app/Main/views/dialogs/kursplanNichtBuchbarDialog.html",
                        controller: "kursplanNichtBuchbarDialogController",
                        controllerAs: "vm",
                        backdrop: "static",
                        resolve: {
                            data: {reason: 5, nutzungsrechtMeldung: subcategory.Buchungssystem_Terminarten.NutzungsrechteMeldung}
                        }
                    });
                } else {
                    subcategory.SliderData = {};
                    subcategory.SliderData.IsSlider = vm.IsSlider;
                    subcategory.SliderData.StartTimeSlider = vm.StartTimeSlider;
                    subcategory.SliderData.EndeTimeSlider = vm.EndeTimeSlider;
                    subcategory.BuchungslimitMitgliedZulassen = vm.layoutSettings.BuchungslimitMitgliedZulassen;
                    SessionService.setSubCategory(subcategory, currency, false);
                    unregisterEventHandler();
                    $state.go('termin', {subcategory: subcategory, cid: $stateParams.cid, id: $stateParams.id, dt: $stateParams.dt})
                }
            });

        };

        vm.moveLeft = function () {
            vm.chunkedCategory = _.chunk(vm.selectedCategory, vm.limitLength);
            vm.lengthChunkedCategorys = (vm.chunkedCategory).length;
            vm.begin--;
            if (vm.begin < 0) {
                vm.begin = vm.lengthChunkedCategorys;
            }
            vm.current = vm.chunkedCategory[vm.begin];
        };

        vm.moveRight = function () {
            vm.chunkedCategory = _.chunk(vm.selectedCategory, vm.limitLength);
            vm.lengthChunkedCategorys = (vm.chunkedCategory).length;
            vm.begin++;
            if (vm.begin === vm.lengthChunkedCategorys) {
                vm.begin = 0;
            }
            vm.current = vm.chunkedCategory[vm.begin];
        };

        vm.goToAngebot = function () {
            $state.go('angebot', {cid: $stateParams.cid, id: $stateParams.id});
            vm.openedMenuBar = false;
        }

        vm.openMenuBar = function () {
            if (vm.openedMenuBar === false) {
                vm.openedMenuBar = true;
            } else {
                vm.openedMenuBar = false;
            }
        };

    }]);
